import React, { useImperativeHandle, forwardRef, useCallback } from "react";
import { Input, Form } from 'antd';
import { KeyOutlined, UserOutlined } from '@ant-design/icons';
import './index.scss';

type FieldType = {
    username?: string;
    password?: string;
};

// 定义 props 类型
interface AccountLoginProps {
    ref?: any;
}

const AccountLogin: React.FC<AccountLoginProps> = forwardRef((props, ref) => {
    const [form] = Form.useForm();

    // 暴露给父组件的值和方法
    useImperativeHandle(ref, () => ({
        getValues,
    }));

    // 表单提交
    const getValues: any = useCallback(() => {
        return new Promise((resolve, reject) => {
            form.validateFields().then((values) => {
                resolve(values);
            }).catch((error) => {
                console.log(error);
            });
        });
    }, [form]);

    return <div className="sso-login-account-mode">
        <Form
            name="account_info"
            form={form}
            initialValues={{
                username: '',
                password: ''
            }}
            autoComplete="false"
        >
            <Form.Item<FieldType>
                name="username"
                rules={[{ required: true, message: '账号不能为空' }]}
            >
                <Input size="large" prefix={<UserOutlined />} placeholder="账号" allowClear />
            </Form.Item>

            <Form.Item<FieldType>
                name="password"
                rules={[{ required: true, message: '密码不能为空' }]}
            >
                <Input.Password size="large" prefix={<KeyOutlined />} placeholder="密码" allowClear />
            </Form.Item>
        </Form>
    </div>
});

export default AccountLogin;